import { Card, Heading, Paragraph } from "@digdir/designsystemet-react";
import { ArrowRightIcon } from "@navikt/aksel-icons";
import "./NavItem.css";

export const NavItem: React.FC<{
    heading: string;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    style?: React.CSSProperties;
    text: string;
}> = ({ heading, onClick, onMouseEnter, onMouseLeave, style, text }) => {
    return (
        <Card
            className="nav-item"
            data-variant="tinted"
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    onClick?.();
                }
            }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            role={onClick ? "button" : undefined}
            style={style}
            tabIndex={onClick ? 0 : -1}
            title={onClick ? "Gå til neste nivå" : undefined}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "var(--ds-size-1)" }}>
                <Heading level={4} data-size="xs">
                    {heading}
                </Heading>
                <Paragraph data-size="sm">{text}</Paragraph>
            </div>

            {onClick && (
                <div className="nav-item__button">
                    <ArrowRightIcon
                        aria-hidden="true"
                        style={{ color: "var(--ds-color-neutral-base-contrast-default)" }}
                        fontSize="var(--ds-font-size-6)"
                    />
                </div>
            )}
        </Card>
    );
};
